import { initializeApp } from "firebase/app";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCH4o_g1dDeLYzaEfqLlxbfgJuJBczTNHs",
  authDomain: "fresho-meat.firebaseapp.com",
  projectId: "fresho-meat",
  storageBucket: "fresho-meat.firebasestorage.app",
  messagingSenderId: "873677086570",
  appId: "1:873677086570:web:473911146a46f97fb58f13",
};

const app = initializeApp(firebaseConfig);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
});
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
export default app;
